/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GetCompanySettingsResponseDataFromJSON, GetCompanySettingsResponseDataToJSON } from './GetCompanySettingsResponseData';
export function UpdateSortCompanySettingsResponseFromJSON(json) {
    return UpdateSortCompanySettingsResponseFromJSONTyped(json, false);
}
export function UpdateSortCompanySettingsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: !exists(json, 'status') ? undefined : json['status'],
        data: !exists(json, 'data') ? undefined : GetCompanySettingsResponseDataFromJSON(json['data'])
    };
}
export function UpdateSortCompanySettingsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: GetCompanySettingsResponseDataToJSON(value.data)
    };
}
